import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { USGenericRoutingModule } from './us-generic-routing.module';
import { USGenericComponent } from './us-generic.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { UpsellModule } from 'src/app/shared/upsell.module';
import { ComponentsModule } from 'src/components/components.module';
import { Storage } from '@ionic/storage-angular';


@NgModule({
  declarations: [
    USGenericComponent,
  ],
  imports: [
    USGenericRoutingModule,
    CommonModule,
    FormsModule,
    RouterModule,
    SharedModule,
    UpsellModule,
    ComponentsModule
  ],
  providers: [
    Storage,
  ],
  exports: [
    USGenericComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class USGenericModule { }





